module.exports = new __parcel__URL__("shop_research_button.296e0a34.png").toString();